/**
 * Labels for groundTruth.expected_behavior. Content-generator projects
 * treat the field as gold output text, not behaviour instructions.
 */
export function expectedBehaviorFieldLabels(isContentGenerator) {
  if (isContentGenerator) {
    return {
      field: "Expected output",
      banner: "EXPECTED OUTPUT",
      helper:
        "Each prompt tests the same expected output — vary input phrasing to probe edge cases.",
      placeholder: "e.g., A 400-word product blog covering noise, power, and warranty.",
    };
  }
  return {
    field: "Expected",
    banner: "EXPECTED",
    helper: "Each prompt tests the same Expected Behavior — vary input phrasing to probe edge cases.",
    placeholder: "e.g., Refer to standard institutional secure lookups.",
  };
}
